import { render, staticRenderFns } from "./ProjectExternalStaffManage.vue?vue&type=template&id=039f8647&scoped=true&"
import script from "./ProjectExternalStaffManage.vue?vue&type=script&lang=js&"
export * from "./ProjectExternalStaffManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039f8647",
  null
  
)

export default component.exports